import { render, staticRenderFns } from "./SurveyManagement.vue?vue&type=template&id=6ccdf961&scoped=true&"
import script from "./SurveyManagement.vue?vue&type=script&lang=js&"
export * from "./SurveyManagement.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagement.vue?vue&type=style&index=0&id=6ccdf961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccdf961",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ccdf961')) {
      api.createRecord('6ccdf961', component.options)
    } else {
      api.reload('6ccdf961', component.options)
    }
    module.hot.accept("./SurveyManagement.vue?vue&type=template&id=6ccdf961&scoped=true&", function () {
      api.rerender('6ccdf961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/SurveyManagement.vue"
export default component.exports